import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styles: [
  ]
})
export class HeaderComponent {
  correo = '';
  Nombre = '';

  constructor(private auth: AuthService) {
    var user = auth.GetUserToken();
    if (user !== null) {
      this.correo = user.Correo;
      this.Nombre = user.UserName;
    }
  }

  salir() {
    this.auth.logOffFull();
  }
}
